import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

export const SurveyUnavailablePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <Result
        status="warning"
        title="Pesquisa indisponível"
        subTitle="Esta pesquisa não está mais disponível para participação."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Ver outras pesquisas
          </Button>
        }
      />
    </div>
  );
};

export default SurveyUnavailablePage;
